/* MATERA shared JS — reveal-on-scroll met vangnet. Sectie-logica zit in de sections zelf. */
(function () {
  /* Animaties alleen aan als JS draait; zonder JS is alles gewoon zichtbaar */
  document.documentElement.classList.add('mt-anim');

  function revealAll() {
    document.querySelectorAll('.matera-page .rv:not(.in)').forEach(function (el) {
      el.classList.add('in');
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.matera-page .rv:not(.in)');
    if (!('IntersectionObserver' in window)) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
    /* Vangnet: wat na 2,5 s nog verborgen is, wordt alsnog getoond */
    setTimeout(revealAll, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  /* Theme editor: her-init wanneer een sectie (opnieuw) geladen of geselecteerd wordt */
  ['shopify:section:load', 'shopify:section:select', 'shopify:section:reorder'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(initReveal, 60); });
  });
})();
